(function () {
  "use strict";
  function ready(fn) {
    if (document.readyState === "loading")
      document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  function play(btn) {
    var frame = btn.closest("[data-cvideo]");
    var src = btn.getAttribute("data-embed");
    if (!frame || !src) return;
    var iframe = document.createElement("iframe");
    iframe.className = "cvideo-iframe";
    iframe.setAttribute("src", src);
    iframe.setAttribute("title", btn.getAttribute("data-title") || "Video");
    iframe.setAttribute(
      "allow",
      "autoplay; fullscreen; picture-in-picture; encrypted-media",
    );
    iframe.setAttribute("allowfullscreen", "");
    frame.innerHTML = "";
    frame.appendChild(iframe);
    iframe.focus();
  }

  function thumbFallback(img) {
    function swap() {
      var fb = img.getAttribute("data-fallback");
      if (fb && !img.__cvSwapped) {
        img.__cvSwapped = true;
        img.src = fb;
      }
    }
    img.addEventListener("error", swap);
    if (img.complete && img.naturalWidth === 0) swap();
  }

  function bind(root) {
    var scope = root || document;
    scope.querySelectorAll("[data-cvideo-play]").forEach(function (btn) {
      if (btn.__cvBound) return;
      btn.__cvBound = true;
      btn.addEventListener("click", function () {
        play(btn);
      });
    });
    scope.querySelectorAll("[data-cvideo-thumb]").forEach(function (img) {
      if (img.__cvBound) return;
      img.__cvBound = true;
      thumbFallback(img);
    });
  }

  ready(function () {
    bind(document);
  });
  document.addEventListener("shopify:section:load", function (e) {
    bind(e.target);
  });
})();
